/** @jsxImportSource @emotion/react */
import 'twin.macro';

import { HTMLProps } from 'react';

type Props = { label: string } & HTMLProps<HTMLInputElement>;

export const SimpleRadio = ({ label, checked, onChange, ...props }: Props) => {
  return (
    <label tw="flex items-center hover:cursor-pointer">
      <input
        type="radio"
        tw="(w-[1.8rem] h-[1.8rem] m-0 mr-[1rem] p-0 accent-color[#5551ff] cursor-pointer bg-transparent)!"
        checked={checked}
        onChange={onChange}
        {...props}
      />
      <span>{label}</span>
    </label>
  );
};
